export default {
  openButton: "Generate curricular structure with AI",
  title: "Quick creation with AI — Curricular Structure",
  close: "Close",
  // Fallbacks for the institutional alternative names: the component passes
  // them through $getVisibleNames and uses these texts when the institution
  // did not rename the concept.
  unitLabel: "Competence Unit",
  studyUnitLabel: "Study Unit",
  studyUnitsLabel: "Study Units",
  criterionLabel: "Achievement Indicator",
  criteriaTitle: "Achievement Indicators",
  contentLabel: "Content",
  contentsTitle: "Contents",
  empty: "There is no curricular structure to show or generated proposals.",
  addUnitButton: "Add {entity} with AI",
  addUnitThemePlaceholder: "Theme for the new {entity} (optional)",
  addUnitThemeHint:
    "Generates a new {entity} with its {study_units}, {criteria} and {contents}.",
  addUnitThemeInfo:
    "Optional: state in a few words the theme or emphasis of the new {entity}; the AI will also generate its {study_units}, {criteria} and {contents}. E.g.: “software quality”, “project management”.",
  addUnitThemeHintNoContents:
    "Generates a new {entity} with its {study_units} and {criteria}.",
  addUnitThemeInfoNoContents:
    "Optional: state in a few words the theme or emphasis of the new {entity}; the AI will also generate its {study_units} and {criteria}. E.g.: “software quality”, “project management”.",
  addStudyUnitButton: "Add {entity} with AI",
  addStudyUnitThemePlaceholder: "Theme for the new {entity} (optional)",
  addStudyUnitThemeHint:
    "Generates a new {entity} (learning outcome) with its {criteria} and {contents}.",
  addStudyUnitThemeInfo:
    "Optional: state in a few words the theme of the new learning outcome; the AI will also generate its {criteria} and {contents}. E.g.: “unit testing”, “NoSQL databases”.",
  addStudyUnitThemeHintNoContents:
    "Generates a new {entity} (learning outcome) with its {criteria}.",
  addStudyUnitThemeInfoNoContents:
    "Optional: state in a few words the theme of the new learning outcome; the AI will also generate its {criteria}. E.g.: “unit testing”, “NoSQL databases”.",
  addCriteriaButton: "Add {entity} with AI",
  addCriteriaThemePlaceholder: "Theme for the new {entity} (optional)",
  addCriteriaThemeHint: "Generates a new {entity} for this {study_unit}.",
  addCriteriaThemeInfo:
    "Optional: state in a few words the aspect the new {entity} should assess. E.g.: “teamwork”, “technical documentation”.",
  addContentButton: "Add {entity} with AI",
  addContentThemePlaceholder: "Theme for the new {entity} (optional)",
  addContentThemeHint: "Generates a new {entity} for this {study_unit}.",
  addContentThemeInfo:
    "Optional: state in a few words the theme of the new {entity}. E.g.: “design patterns”, “advanced SQL queries”.",
  generating: "Generating content with AI...",
  generateError: "The content could not be generated. Please try again later.",
  cancel: "Cancel",
  confirmSave: "Confirm and save",
  savedToast: "Objects created successfully.",
  saveError:
    "An error occurred while saving the generated objects. Please try again.",
};
